(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("4ojSe", function(module, exports) {

$parcel$export(module.exports, "datalayerPush", function () { return $3328d1d4931c24f3$export$9018d86ce0edccfd; });
var $3328d1d4931c24f3$var$clickEventPushElements = document.querySelectorAll("[data-click-event-push]");
var $3328d1d4931c24f3$export$9018d86ce0edccfd = function(json) {
    var parsedJson = typeof json === "string" ? JSON.parse(json) : json;
    if (!parsedJson) return;
    parsedJson._clear = true;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(parsedJson);
};
$3328d1d4931c24f3$var$clickEventPushElements.forEach(function(element) {
    var json = element.dataset.clickEventPush;
    if (!json) return;
    element.addEventListener("click", function() {
        return $3328d1d4931c24f3$export$9018d86ce0edccfd(json);
    });
});

});

})();
//# sourceMappingURL=datalayer-push.ad1c8e34.js.map
